// The Workbench polish's registrations (B10 slice S21), loaded by ../register.ts. The Coordinator Workbench screen is
// B5's (`#workbench`): *Saved views* mount in its filter row through B5's Workbench slot (C-B10-13), gated on
// `saved_view.list`, and the drill-in query that ./query.ts writes is the one B5's page reads, so S21 registers no
// route of its own. The `panel_ack` Home widget draws B6's acknowledgments, given by app/reporting/panel_ack.py.
import { registerWorkbenchSlot } from "@/views/scheduling/slots";
import { registerHomeWidget } from "@/views/home/widgets";
import { homeView } from "../home/register";
import { AckWidget } from "./AckWidget";
import { WorkbenchViewsSlot } from "./WorkbenchViews";

/** CR-051 "… saved views …" on the Workbench (DC-155 "Filters, saved views and grouping as the chip row."). */
registerWorkbenchSlot("saved_views", "filters", WorkbenchViewsSlot, { lane: "B10", gates: ["saved_view.list"] });

/** CR-086 "Panel acknowledgment summary": drawn when B6's summary gives Home a `panel_ack` widget. */
registerHomeWidget("panel_ack", homeView(AckWidget));
